import React from "react";
import logo from "../images/logo/logo.gif";

function Loading() {
  return (
    <div className="loading_wrapper">
      <img src={logo} alt="" />
    </div>
  );
}

export default Loading;
